import type { CommonStatusUILabel } from '@@partner:types:app'
import type { ProductReviewFiltersType } from '@components/catalog/productReview/grid/ProductReviewFilter'

import { makeFilter } from '@@partner:helpers/crud/filters'
import { formatProductReviewStatusLabel } from '@@partner:helpers/formatters/productReview'

import {
  PRODUCT_REVIEW_STATUS_REJECTED,
  PRODUCT_REVIEW_STATUS_AWAITING_MODERATION,
  PRODUCT_REVIEW_STATUS_PASSED_MODERATION
} from '@@partner:config/productReview-status-codes'

interface ProductStatusUISettings extends CommonStatusUILabel {
  value: number
}

export function getSearchableProductReviewStatuses (): ProductStatusUISettings[] {
  const SEARCHEBLE_PRODUCT_REVIEW_STATUSES = [
    PRODUCT_REVIEW_STATUS_REJECTED,
    PRODUCT_REVIEW_STATUS_AWAITING_MODERATION,
    PRODUCT_REVIEW_STATUS_PASSED_MODERATION
  ]

  return SEARCHEBLE_PRODUCT_REVIEW_STATUSES.map((statusCode) => {
    const statusConfig = formatProductReviewStatusLabel(statusCode)

    return {
      value: statusCode,
      label: statusConfig.label,
      color: statusConfig.color
    }
  })
}

export const prepareProductReviewFilter = (
  filters: ProductReviewFiltersType
) => {
  const productIdsFilter = makeFilter(
    'product_id',
    'contains',
    filters.productIds
  )
  const productXidFilter = makeFilter(
    'productXid',
    'contains',
    filters.productXid
  )
  
  const statusFilter = makeFilter('status', 'contains', filters.statuses)
  return {
    and: [ productIdsFilter, productXidFilter, statusFilter ]
  }
}
